import React, { Component } from 'react'
import Button from './Button'
import styles from './BigButton.css'
import BigButtonDisabled from './BigButtonDisabled'

const BigButton = props => {
    if(props.disabled) {
        return <BigButtonDisabled {...props} />
    }
    return <Button className={styles.bigbutton} {...props} />
}

export default BigButton
